import React from "react";
import ReactDOM from "react-dom";
// import Handlebars from "handlebars";
const { data } = require('./Projects.data');

import "./Projects.scss";

// const htmlContent = require("./Projects.html");
import htmlContent from './Projects.hbs';// works as template fn

// const template = Handlebars.compile(htmlContent);// fails

const Projects = (props) => {

  const {
    // data
  } = props;

  const h_cont = htmlContent(data);

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: h_cont }} className={`hbs_comp plax-bg`} />
      {/* <div dangerouslySetInnerHTML={{ __html: template(data) }} /> */}
    </>
  );
}

export default Projects
